import type { Provider } from '@angular/core';
import { ApplicationModulesService } from './application-modules.service';
import { ApplicationModulesServiceAdapter } from './application-modules.service.adapter';

export function provideApplicationModulesDomain(): Provider[] {
    return [
        {
            provide: ApplicationModulesService,
            useClass: ApplicationModulesServiceAdapter
        }
    ];
}
